import { useReveal } from '../../../core/hooks/useReveal';

import './styles/Reveal.css';

export default function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
    const { ref, isVisible } = useReveal();

    return (
        <Tag
            ref={ref}
            className={`reveal ${isVisible ? 'reveal--visible' : ''} ${className}`.trim()}
            style={{ '--reveal-delay': `${delay}ms` }}
            {...rest}
        >
            {children}
        </Tag>
    );
}
